import * as React from 'react'
import FormFields from './FormFields'
import * as Styled from './Form.styles'
import DetermineFieldType from './DetermineFieldType'

const FormSteps = ({
  currentStep,
  formDisclaimerPosition,
  formName,
  nextStep,
  steps,
  submitButton,
  tcpaCheckbox,
  disclaimer = null,
  smartyStreetsWebsiteKey = null,
}) => (
  <>
    <FormFields
      className={`step-${currentStep + 1} ${formName}`}
      nextStep={nextStep}
      submitButton={submitButton}
      fields={steps[currentStep].formFields}
      additional={
        currentStep + 1 === steps.length && (
          <>
            <Styled.TCPADisclaimerContainer>
              {tcpaCheckbox &&
                formDisclaimerPosition === 'Above Submit Button' && (
                  <DetermineFieldType
                    submitButton={submitButton}
                    field={{
                      type: 'checkbox',
                      element: 'checkbox',
                      name: 'tcpa-checkbox',
                      required: true,
                      options: [
                        {
                          name: 'consent',
                          value: 'yes',
                          label: '',
                        },
                      ],
                    }}
                  />
                )}
              {disclaimer &&
                formDisclaimerPosition === 'Above Submit Button' && (
                  <Styled.FormDisclaimer {...disclaimer.brandy} />
                )}
            </Styled.TCPADisclaimerContainer>

            {submitButton}

            <Styled.TCPADisclaimerContainer>
              {tcpaCheckbox &&
                formDisclaimerPosition !== 'Above Submit Button' && (
                  <DetermineFieldType
                    submitButton={submitButton}
                    field={{
                      type: 'checkbox',
                      element: 'checkbox',
                      name: 'tcpa-checkbox',
                      required: true,
                      options: [
                        {
                          name: 'consent',
                          value: 'yes',
                          label: '',
                        },
                      ],
                    }}
                  />
                )}
              {disclaimer &&
                formDisclaimerPosition !== 'Above Submit Button' && (
                  <Styled.FormDisclaimer {...disclaimer.brandy} />
                )}
            </Styled.TCPADisclaimerContainer>
          </>
        )
      }
      radioFieldsAsButtons
      smartyStreetsWebsiteKey={smartyStreetsWebsiteKey}
    />
    <Styled.StepCounter className="leshen-form-step-counter" variant="small">
      Step {currentStep + 1} of {steps.length}
    </Styled.StepCounter>
  </>
)

export default FormSteps
